<mat-dialog-content>
    <h4>Cookies</h4>
    <p>Most websites use cookies. Cookies are small text files placed on your device to store
        data so web servers can use it later. Tin Arm Engineering and our third-party partners
        use cookies to remember your preferences and to help you sign in.</p>

    <h4>Required</h4>
    <p>Tin Arm Engineering uses required cookies to log you in and authenticate traffic between
        web servers.
    </p>
    <h4>Analytics, Social Media and Advertising</h4>
    <p>Tin Arm Engineering does not use analytics, social media or advertising cookies.</p>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton mat-dialog-close class="btn btn-primary">OK</button>
</mat-dialog-actions>



<!-- Copyright 2025 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->